var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.5 4a1 1 0 0 1 1 1v14a1 1 0 1 1-2 0v-6h-8v6a1 1 0 1 1-2 0V5a1 1 0 0 1 2 0v6h8V5a1 1 0 0 1 1-1M18.5 10a3 3 0 0 1 3 3c0 .77-.292 1.469-.769 2 .477.531.769 1.23.769 2a3 3 0 1 1-6 0 1 1 0 0 1 1.995-.102l.01.204a1 1 0 1 0 1.098-1.097l-.206-.01a1 1 0 0 1 0-1.99l.206-.01a1 1 0 1 0-1.098-1.097l-.01.204A1 1 0 0 1 15.5 13a3 3 0 0 1 3-3"
  })));
};
export default Svg24;